import en from './en'
import fr from './fr'

const langs={ en, fr };

export default langs;
